import React from 'react';
import { useNavigate } from 'react-router-dom';
import './BookingPage.css';

const BookingPage = () => {
  const navigate = useNavigate();
  return (
    // <div className="main-content">
        <div className="home-content">
          <div className="booking-grid">
            <div className="booking-card">
              <h2 className="booking-title">
                Speak with a Counselor First: Free 15-Minute Consultation
              </h2>
              <p className="booking-text">
                Prefer to discuss your concerns with a compassionate counselor before connecting with a psychiatrist? This <span className="font-semibold">free, confidential 15-minute call allows our experienced counselor to understand your needs, answer your questions, and personally match you with a certified psychiatric doctor specializing in your area of concern.</span> It's a gentle first step towards personalized care.
              </p>
              <button 
                className="booking-button"
                onClick={() => navigate('/booking-form')}
              >
                Book Free Counselor Call
              </button>
            </div>
            <div className="booking-card">
              <h2 className="booking-title">
                Book Your Call with an Expert Psychiatric Doctor
              </h2>
              <p className="booking-text">
                Ready to connect with a psychiatrist? Simply share your concerns and symptoms through our secure form. Our <span className="font-semibold">intelligent system will then carefully match you with one of our certified, expert psychiatric doctors</span> who specializes in your specific needs, allowing you to book your call for dedicated guidance and support.
              </p>
              <button 
                className="booking-button"
                onClick={() => navigate('/doctor-booking')}
              >
                Book My Doctor
              </button>
            </div>
          </div>
        </div>
    //   </div>
    // </div>
  );
};

export default BookingPage; 